import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { generalResolver } from "./generalValidations";
import { emergencyContactSchema, profileContact } from "./contactValidations";

const phonePattern = /^\d*$/;
const date = z
  .string({ message: "Invalid Format. YYYY-MM-DD Format." })
  .date("Invalid Format. YYYY-MM-DD Format.");

export const resolver = zodResolver(
  z.object({
    email: z
      .string({
        message: "Must be a valid email address (e.g., example@example.com)",
      })
      .email({
        message: "Must be a valid email address (e.g., example@example.com)",
      })
      .max(100, { message: "Must be 100 or fewer characters long" }),
    givenName: z
      .string({ message: "Given name is required" })
      .max(250, { message: "Must be 100 or fewer characters long" }),
    nickname: z
      .string()
      .max(100, { message: "Must be 100 or fewer characters long" })
      .nullish(),
    dob: date,
    gender: z.optional(z.string().max(10)),
    maritalStatus: z.optional(z.string().max(10)),
    genderIdentity: z.optional(z.string()),
    sexualOrientation: z.optional(z.string()),
    ssn: z
      .string()
      .max(11, { message: "Must be 11 characters long" })
      .regex(/^$|^\d{3}-\d{2}-\d{4}$/, {
        message: "Invalid SSN format. Must be 000-00-0000",
      })
      .nullish(),
    otherFirstName: z.optional(
      z.string().max(100, { message: "Must be 100 or fewer characters long" })
    ),
    otherLastName: z.optional(
      z.string().max(100, { message: "Must be 100 or fewer characters long" })
    ),
    otherMiddleName: z.optional(
      z.string().max(100, { message: "Must be 100 or fewer characters long" })
    ),
    generalResult: generalResolver,
    profileContact: profileContact,
    emergencyContacts: z.array(emergencyContactSchema),
  })
);
